import { http } from './http';
import { api } from './endpoints';
import { SearchResults } from '@/vue_components/content-search/composables/useContentSearch';

export const searchService = {


    suggestFullText(keyword: string) {
        return http.get(api.search.suggestFullText(keyword)).then(r => r.data);
    },
    letterIndex(letter: string) {
        return http.get(api.search.letterIndex(letter)).then(r => r.data);
    },
    searchCategories() {
        return http.get(api.search.searchCategories).then(r => r.data);
    },
    
     otcCategorySearch() {
         return http.get(api.search.otcCategorySearch).then(r => r.data);
     },
    
    
    praeparatById(id: number | string) {
        return http.get(api.search.praeparatById(id)).then(r => r.data);
    },
    
    suggestPraeparatName(keyword: string) {
       return http.get(api.search.suggestPraeparatName(keyword)).then(r => r.data);
    },
    praeparateSearchCount() {
        return http.get(api.search.praeparateSearchCount).then(r => r.data);
    },
    praeparateFullText(keyword:string, start: number, take:number){
        return http.get(api.search.fullText(keyword, start, take)).then(r => new SearchResults(r.data));
    },
    
    contentSuggest(keyword: string) {
        return http.get(api.search.content.suggest(keyword)).then(r => r.data);
    },
    contentFullText(keyword: string, category:string,start:number, take:number){
        return http.get(api.search.content.fullText(keyword, category, start, take)).then(r => new SearchResults(r.data));
    },
    mediaSuggest(keyword: string) {
        return http.get(api.search.media.suggest(keyword)).then(r => r.data);
    },
    mediaFullText(keyword: string, start:number, take:number) {
        return http.get(api.search.media.fullText(keyword, start, take)).then(r => new SearchResults(r.data));
    },

    // newsSuggest(keyword: string) {
    //     return http.get(api.search.news.suggest(keyword)).then(r => r.data);
    // },
    // newsFullText(keyword: string) {
    //     return http.get(api.search.news.fullText(keyword)).then(r => r.data);
    // },
    // highlightedNews(category: string) {
    //     return http.get(api.search.news.highlighted(category)).then(r => r.data);
    // },
    // newsByCategory(category: string) {
    //     return http.get(api.search.news.byCategory(category)).then(r => r.data);
    // },
    // newsById(id: number | string) {
    //     return http.get(api.search.news.byId(id)).then(r => r.data);
    // },
};
export type SearchService = typeof searchService;
